import { useEffect, useState } from 'react';

/** Relógio que avança no front para contadores (ociosidade etc.). */
export function useTickingNow(intervalMs = 15000) {
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        const safeInterval = Math.max(1000, Number(intervalMs) || 15000);
        const id = setInterval(() => {
            setNow(Date.now());
        }, safeInterval);
        return () => clearInterval(id);
    }, [intervalMs]);

    return now;
}
